import { ReactElement, useMemo } from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../../../theme/colors';
import { SelectItem } from '../../../types';
import { Checkbox } from '../../Checkbox/Checkbox';

interface Props {
  item: SelectItem;
  selectedItems: SelectItem[];
  onSelect: (item: SelectItem) => void;
}

interface StyledOptionProps {
  isHighlighted: boolean;
}

export const StyledOption = styled('li')<StyledOptionProps>`
  height: 32px;
  margin-bottom: 8px;
  padding-left: 7px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  cursor: pointer;
  ${({ isHighlighted, theme }) => (isHighlighted ? `background: ${theme.colors.primary[5]};` : '')}

  :hover {
    background: ${({ theme }) => theme.colors.primary[5]};
  }
`;

export const CheckboxWrapper = styled('div')`
  margin-right: 12px;
`;

export const MultiselectOption = ({ item, selectedItems, onSelect }: Props): ReactElement => {
  const isSelected = useMemo(
    () => selectedItems.some((listItem) => listItem.id === item.id),
    [item.id, selectedItems]
  );
  return (
    <StyledOption isHighlighted={isSelected} onClick={() => onSelect(item)} role='option'>
      <CheckboxWrapper>
        <Checkbox checked={isSelected} readOnly />
      </CheckboxWrapper>
      <Typography variant='body2' color={colors.primary[100]}>
        {item.value}
      </Typography>
    </StyledOption>
  );
};
